import { useEffect, useState } from 'react'
import cn from 'clsx'

// Components
import { Button, IconCheck, IconPen } from '@tracklib/kit'
import FirstName from 'components/interestform/formcomponents/name/firstname'
import LastName from 'components/interestform/formcomponents/name/lastname'

// Utils
import styles from './name.css'

type NameProps = {
  onReview: boolean
  firstName?: string
  lastName?: string
}

const Name = (props: NameProps): JSX.Element => {
  const { onReview, firstName, lastName } = props
  const [isEditing, setIsEditing] = useState(true)

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  return (
    <div className={styles.namesWrapper}>
      <div className={cn(styles.names, !isEditing && styles.namesDisplay)}>
        <FirstName firstName={firstName} onReview={onReview} isEditing={isEditing} />
        <LastName lastName={lastName} onReview={onReview} isEditing={isEditing} />
      </div>
      {onReview && !isEditing && (
        <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
          <IconPen />
        </Button>
      )}
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default Name
